import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { localize } from '../../utils/TranslationUtils'

import SocialLink from './SocialLink'
import styles from './styles'


const decorators = [
  localize,
  memoized,
]

function SocialBar(props) {
  const { copyright, className, t } = props

  return (
    <div className={classnames('container', className)}>
      <ul>
        <li>
          <SocialLink
            label={t('linkedinLabel')}
            href={t('linkLinkedInBbs')}
            target="_blank"
          />
        </li>
        <li>
          <SocialLink
            label={t('instagramLabel')}
            href={t('linkInstagramBbs')}
            target="_blank"
          />
        </li>
        <li>
          <SocialLink
            label={t('youtubeLabel')}
            href={t('linkYoutubeBbs')}
            target="_blank"
          />
        </li>
      </ul>
      <p>{copyright}</p>
      <style jsx>{styles}</style>
    </div>
  )
}

SocialBar.propTypes = {
  copyright: PropTypes.string,
  className: PropTypes.string,
}

SocialBar.defaultProps = {
  copyright: '',
  className: null,
}

SocialBar = chainDecorators(decorators, SocialBar)

export default SocialBar
